/** The browser's IANA timezone, sent so the server can render prompt dates on
 * the user's own clock instead of UTC. Without it the server falls back to the
 * tenant's configured timezone (TenantConfig.timezone), then UTC. */
export function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    return "";
  }
}

/** Spread into a fetch's headers to carry the browser timezone. Empty when the
 * zone can't be resolved, so it never sends a header the server would reject. */
export function tzHeaders(): Record<string, string> {
  const tz = browserTimezone();
  return tz ? { "X-User-Timezone": tz } : {};
}
